export default (token: string) => {
  if (localStorage) {
    localStorage.setItem('token', token);
  } else {
    document.cookie = `token=${token}`;
  }
};
